import * as React from "react";
import { Paper, Avatar, Box, Typography } from "@mui/material";
import random from "../../../../utils/random.jpg";

const EmployeeHeadBasic = ({singleEmployeeData} ) => {
  
  return (
    <Paper>
      <Box
        sx={{
          bgcolor: "white",
          marginBottom: "10px",
          width: "100%",
          padding: { sm: "20px 30px", xs: "0" },
          display: "flex",
          flexDirection: "row",
          flexWrap: "wrap",
          boxSizing:'border-box'
        }}
      >
        <Avatar
          sx={{ width: 66, height: 66 }}
          alt={singleEmployeeData?.name}
          src={random}
        />
        <Box sx={{ margin: " 0 25px" }}>
          <Typography variant="body2" gutterBottom>
            <span style={{ fontWeight: "bold" }}>
              {singleEmployeeData?.name}
            </span>
            <span>&nbsp; ({singleEmployeeData?.designation_name})</span>
            <br /> {singleEmployeeData?.email} <br /> {singleEmployeeData?.code}
          </Typography>
        </Box>
      </Box>
    </Paper>
  );
};
export default EmployeeHeadBasic;
 